import { render, staticRenderFns } from "./ClassicLoginModal.vue?vue&type=template&id=edc073e0&scoped=true"
import script from "./ClassicLoginModal.vue?vue&type=script&lang=js"
export * from "./ClassicLoginModal.vue?vue&type=script&lang=js"
import style0 from "./ClassicLoginModal.vue?vue&type=style&index=0&id=edc073e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc073e0",
  null
  
)

export default component.exports